<ng-container>
  <h3 mat-dialog-title i18n="@@308233510382796132" t="308233510382796132">Diversity Details</h3>
    <diversity-edit #diversityedit *ngIf="supplierDiversity" [tsl-supplierDiversity]="supplierDiversity">
    </diversity-edit>
    <br>
    <div class="right">
        <button tsl-button size="small" color="black" outline (click)="onCancel()">Close</button>
        <button tsl-button size="small" color="blue" filled (click)="onSubmit()">Submit</button>
    </div>
</ng-container>
